'use client';
import { useEffect, useRef } from 'react';
/**
 * Returns the value passed on the previous render, or `undefined` on the first
 * render.
 */
export function usePrevious(value) {
    const ref = useRef(undefined);
    useEffect(() => {
        ref.current = value; //assign the value of ref to the argument
    }, [value]); //this code will run when the value of 'value' changes
    return ref.current; //in the end, return the current ref value.
}
//# sourceMappingURL=usePrevious.js.map